module.exports = __webpack_public_path__ + "images/emoji/open_book.df720d6a938598e37ba3.png";